__turbopack_context__.v({
  "className": "orbitron_16953664-module__xJrwUa__className",
});
